import { connect, MapDispatchToProps, MapStateToProps } from 'react-redux';
import {
  selectors as streamSelectors,
  withOffset,
} from '@wix/da-shared-react/pkg/Stream';
import { unfeaturePost } from '../../../../../actions/feed';
import { getDeviationsByIds } from '@wix/da-shared-react/pkg/redux/deviations/selectors';
import { editDeviation } from '@wix/da-shared-react/pkg/redux/deviations/actionCreators';
import { AppState } from '../../../../../../types/store';
import { isCurrentUserProfileOwner } from '../../../../../selectors/users';
import { Props } from './FeaturedList';

type StateProps = Pick<
  Props,
  'items' | 'hasMore' | 'isFetching' | 'isEmpty' | 'isOwner'
>;
type DispatchProps = Pick<Props, 'fetchMore' | 'editItem' | 'unfeatureItem'>;
type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, AppState> = (
  state: AppState,
  { streamId }: OwnProps
) => {
  const items = getDeviationsByIds(
    state,
    streamSelectors.getItems(state, streamId)
  );
  const hasMore = streamSelectors.hasMore(state, streamId);
  const isFetching = streamSelectors.isFetching(state, streamId);
  const isInitialized = streamSelectors.isInitialized(state, streamId);
  const isEmpty = isInitialized && !isFetching && items.length === 0;
  const isOwner = isCurrentUserProfileOwner(state);
  return {
    items,
    hasMore,
    isFetching,
    isEmpty,
    isOwner,
  };
};

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = (
  dispatch,
  { streamId }
) => ({
  fetchMore: () => dispatch(withOffset.actions.fetch(streamId)),
  editItem: deviation => dispatch(editDeviation({ deviation })),
  unfeatureItem: item => dispatch(unfeaturePost({ item })),
});

export default connect(mapStateToProps, mapDispatchToProps);
